import React from 'react'

import { useAppDispatch } from 'planner-upgrades/redux/hooks'
import { startTicker } from 'actions/intervalTasks'

const TaskTickerManager = () => {
  const dispatch = useAppDispatch()
  React.useEffect(() => dispatch(startTicker()), [dispatch])
  return null
}

export default TaskTickerManager
